// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3bTcL","col":"styles_col__2sfdL"};